"use client"

import { Toaster as Sonner, ToasterProps } from "sonner"
import { useEffect } from "react"
import React from "react"
import { addProgressBarAndStyles, createToast, iconConfig } from "./helpers"
import { Inter } from "next/font/google"

const inter = Inter({
  subsets: ["latin"],
  display: "swap",
  variable: "--font-inter",
})

// Toast Alert Wrapper
export const toastAlert = Object.fromEntries(
  Object.keys(iconConfig).map((type) => [
    type,
    (title: string, description: string) => createToast(type as keyof typeof iconConfig, title, description),
  ])
) as Record<keyof typeof iconConfig, (title: string, description: string) => void>

const ShadCnToaster = ({ ...props }: ToasterProps) => {
  // const { theme = "system" } = useTheme()

  useEffect(() => {
    addProgressBarAndStyles()

    const observer = new MutationObserver(() => {
      addProgressBarAndStyles()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Sonner
      // theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      duration={2000}
      toastOptions={{
        duration: 2000,
        classNames: {
          toast: `group toast pointer-events-auto overflow-hidden rounded-lg  ${inter.variable}`,
          title: "font-inherit",
          description: "text-gray-600 font-inherit",
          actionButton: "bg-blue-600 text-white hover:bg-blue-700",
          cancelButton: "bg-gray-100 text-gray-600 hover:bg-gray-200",
          error: "",
          success: "",
          warning: "",
          info: "",
        },
      }}
      {...props}
    />
  )
}

export { ShadCnToaster }
